import { render, staticRenderFns } from "./Repost.vue?vue&type=template&id=72bfc370&scoped=true&"
import script from "./Repost.vue?vue&type=script&lang=js&"
export * from "./Repost.vue?vue&type=script&lang=js&"
import style0 from "./Repost.vue?vue&type=style&index=0&id=72bfc370&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfc370",
  null
  
)

export default component.exports